/// <amd-module name="TFS/Admin/Common/Util/CustomErrorHelper" />
import { caseInsensitiveContains } from "VSS/Core/Util/String";
import { CustomErrorSearchString } from "TFS/Admin/Common/Constants/CustomErrorConstants";
import AdminResources = require("TFS/Admin/Common/Resources");

export function CleanErrorMessage(errorMessage?: string): string {
    if (!errorMessage) {
        return "";
    }

    errorMessage = errorMessage.toString();

    if (caseInsensitiveContains(errorMessage, CustomErrorSearchString.CollectionAlreadyLinked)) {
        return AdminResources.OrganizationAlreadyLinked;
    }

    if (
        caseInsensitiveContains(errorMessage, CustomErrorSearchString.UnexpectedJsonToken) ||
        caseInsensitiveContains(errorMessage, CustomErrorSearchString.JsonParseError)
    ) {
        return AdminResources.ErrorOccurredPleaseTryAgain;
    }

    if (caseInsensitiveContains(errorMessage, CustomErrorSearchString.CollectionNotLinked)) {
        return AdminResources.OrganizationNotYetLinked;
    }

    if (caseInsensitiveContains(errorMessage, CustomErrorSearchString.IdentityMaterializationFailure)) {
        var regEx = new RegExp(CustomErrorSearchString.IdentityMaterializationFailure, "ig");
        return errorMessage.replace(regEx, "");
    }
    if (caseInsensitiveContains(errorMessage, CustomErrorSearchString.UserNeedsSignIn)) {
        var regEx = new RegExp(CustomErrorSearchString.UserNeedsSignIn, "ig");
        return errorMessage.replace(regEx, "");
    }
    if (caseInsensitiveContains(errorMessage, CustomErrorSearchString.UserNotAuthorized)) {
        return AdminResources.UserNotAuthorized;
    }
    if (caseInsensitiveContains(errorMessage, CustomErrorSearchString.NetworkConnectionError)) {
        var regEx = new RegExp(CustomErrorSearchString.NetworkConnectionError, "ig");
        return errorMessage.replace(regEx, "");
    }
    if (caseInsensitiveContains(errorMessage, CustomErrorSearchString.MicrosoftEmailAddress)) {
        var regEx = new RegExp(CustomErrorSearchString.MicrosoftEmailAddress, "ig");
        return errorMessage.replace(regEx, "");
    }
    if (caseInsensitiveContains(errorMessage, CustomErrorSearchString.MoreThanOneCollection)) {
        var regEx = new RegExp(CustomErrorSearchString.MoreThanOneCollection, "ig");
        return errorMessage.replace(regEx, "");
    }
    if (caseInsensitiveContains(errorMessage, CustomErrorSearchString.ExistingMembership)) {
        return AdminResources.AadMapExistingMembershipError;
    }
    if (caseInsensitiveContains(errorMessage, CustomErrorSearchString.AcyclicMember)) {
        return AdminResources.AcyclicMember;
    }

    return errorMessage;
}

export function ParseErrorFromAPI(error: any): string {
    if (error.serverError) {
        if (error.serverError.message) {
            return JSON.stringify(error.serverError.message);
        }
        return JSON.stringify(error.serverError);
    } else if (error.message) {
        return JSON.stringify(error.message);
    }
    return JSON.stringify(error);
}
